import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/services/auth.service';
import { LoginService } from 'src/app/core/services/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  isLoading = false;
  isPassword = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private loginService: LoginService,
    private authService: AuthService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.createForm();
  }
  showPassword() {
    this.isPassword = !this.isPassword;
  }
  private createForm() {
    this.loginForm = this.formBuilder.group({
      email: [
        '',
        Validators.compose([
          Validators.required,
          Validators.email,
          //Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')
        ]),
      ],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(6), //pendiente Sarahi dijo 7 pero el usuario de prueba tiene 6
          Validators.maxLength(10),
          Validators.pattern('^[a-zA-Z0-9]+$'),
        ],
      ],
      remember: true,
    });
    console.log(this.loginForm.value);
  }
  login() {
    this.isLoading = true;
    this.loginService.login(this.loginForm.value).subscribe(
      (res: any) => {
        this.isLoading = false;
        console.log(res);
        const data = {
          id: res.user.id,
          email: res.user.email,
          name: res.user.name,
          token: res.authorisation.token,
          // roles: res.data.roles.admin,
          roles: res.roles,
          permissions: res.permissions,
        };
        this.authService.setUserCredentials(
          data,
          this.loginForm.value.remember
        );
      },
      (err: any) => {
        this.isLoading = false;
        if (err.error.error == 'Unauthorized') {
          this.toastr.error(
            'Email o contraseña incorrectos',
            'Error al iniciar Sesión'
          );
        }

        console.log(err);
      }
    );
  }
  get email() {
    return this.loginForm.get('email');
  }
  get password() {
    return this.loginForm.get('password');
  }
}
